export default "__VITE_ASSET__4be603f5__"